import React from 'react';
import styles from './Blog.module.scss';
import Typography from '@material-ui/core/Typography';
import Section from '../Section';
import Feed from '../Feed';
import GatsbyLink from 'gatsby-link';


const Blog = ({edges, location}) => {
    const categoriesMap = edges.reduce((acc, edge) => {
        const {node: {frontmatter, fields}} = edge;
        if (!acc[frontmatter.category]) {
            acc[frontmatter.category] = fields.categorySlug
        }
        return acc
    }, {});


    return (
        <Section backgroundColor="#F7F8FB" height="auto">
            <div className={styles.blog}>
                <Typography variant="h1" color="secondary">
                    Blog
                </Typography>
                <div className={styles['tag-list']}>
                    <GatsbyLink to='/blog'
                                activeClassName={styles['active']}>
                        ALL POSTS
                    </GatsbyLink>
                    {Object.keys(categoriesMap).map(category => (
                        <GatsbyLink
                            key={category}
                            activeClassName={styles['active']}
                            to={categoriesMap[category]}>
                            {category}
                        </GatsbyLink>
                    ))}
                </div>
                <div className={styles['blog__posts']}>
                    <Feed edges={edges}/>
                </div>
            </div>
        </Section>
    );
};

export default Blog;
